module.exports = "<p>\n  nomination-rec-form works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/Nomination/nomination-rec/nomination-rec-form/nomination-rec-form.component.html
// module id = ./src/app/hrms/Nomination/nomination-rec/nomination-rec-form/nomination-rec-form.component.html
// module chunks = main